import { useQuery, keepPreviousData, useMutation } from '@tanstack/react-query'
import { User } from '../../shared/types'
import { del, get, post } from '../fetch'
import { ParamsType } from '../scaffolding/types'

export type UsersParamsType = {
	id?: string
	email?: string
	accountRoleIds?: Array<string | number>
}

export function useUserList(searchParams: ParamsType & UsersParamsType) {
	return useQuery({
		queryKey: ['api/user', searchParams],
		queryFn: () => post<{ total: number; list: User[] }>(`/api/0/user`, searchParams),
		placeholderData: keepPreviousData,
	})
}

export function useUserGet(id?: string) {
	return useQuery({
		queryKey: ['api/user', id],
		queryFn: () => get<User>(`/api/0/user/${id}`),
		enabled: !!id,
	})
}

export function useUserSetRole(id: string) {
	return useMutation({
		mutationFn: (data: FormData) => post(`/api/0/user/${id}/set-role`, data),
		meta: {
			invalidateQueries: [['api/user'], ['api/me', 'account-permissions']],
			notifications: {
				success: () => 'Role změněna',
			},
		},
	})
}

export function useUserRemove() {
	return useMutation({
		mutationFn: (id: string) => del(`/api/0/user/${id}`),
		meta: {
			invalidateQueries: [['api/user']],
			notifications: {
				success: () => 'Uživatel odstraněn',
			},
		},
	})
}

export function useUserInvite() {
	return useMutation({
		mutationFn: (data: FormData) => post('/api/0/user/invite', data),
		meta: {
			notifications: {
				success: () => 'Pozvánka odeslána',
			},
		},
	})
}
